<ng-container *transloco="let t">
  <!-- EXERCSIE + AUTHED -->
  <div class="slot-line p-d-flex p-jc-between" *ngIf="auth.isSlotVisible(slot, group)" (click)="openSlot()">
    <div class="name" *ngIf="getStartTime() as time">
      {{ time | timezoneTime | amDateFormat: 'HH:mm' }}&nbsp;
      <span class="timezone-times">({{ time | amDateFormat: 'HH:mm' }})&nbsp;</span>
      <ng-container *ngIf="!canOpenSlot()">{{ slot.name }}</ng-container>
      <a *ngIf="canOpenSlot()" (click)="dummy()">{{ slot.name }}</a>
      <span class="duration">({{ slot.duration }} {{ t('common.labels.minutes') }})</span>
      <app-agenda-participant-icons
        *ngIf="auth.isModerator()"
        [slot]="slot"
      ></app-agenda-participant-icons>
    </div>
    <div class="timer-controls">
      <app-timer [slot]="slot" [candidate]="candidate" [group]="group"></app-timer>
      <app-controls-slot *ngIf="canControlSlot()" [slot]="slot" [candidate]="candidate" [group]="group"></app-controls-slot>
    </div>
  </div>
  <!-- EXERCSIE + NOT AUTHED -->
  <div *ngIf="!auth.isSlotVisible(slot, group) && !isLastSlot()" class="slot-line p-d-flex p-jc-between short-break">
    <div class="name" *ngIf="getStartTime() as time">
      {{ time | timezoneTime | amDateFormat: 'HH:mm' }}&nbsp;
      <span class="timezone-times">({{ time | amDateFormat: 'HH:mm' }})&nbsp;</span>
      <ng-container>{{ t('common.labels.short_break') }}</ng-container>
    </div>
  </div>
  <!-- RATING + AUTHED -->
  <div *ngIf="slot.rating_start === 'end' && (auth.isObserver() || auth.isModerator())" (click)="openRating()" class="slot-line p-d-flex p-jc-between">
    <div class="name" *ngIf="getStartTime('rating') as time">
      {{ time | timezoneTime | amDateFormat: 'HH:mm' }}&nbsp;
      <span class="timezone-times">({{ time | amDateFormat: 'HH:mm' }})&nbsp;</span>
      <ng-container *ngIf="!canOpenRating()">{{ t('common.labels.rating') }}</ng-container>
      <a *ngIf="canOpenRating()" (click)="dummy()">{{ t('common.labels.rating') }}</a>
      <span class="duration">({{ slot.rating_duration }} {{ t('common.labels.minutes') }})</span>
      <app-agenda-participant-icons
        *ngIf="auth.isModerator()"
        [slot]="slot"
        [mode]="'rating'"
      ></app-agenda-participant-icons>
    </div>
    <div class="timer-controls">
      <app-timer [slot]="slot" [candidate]="candidate" [group]="group" [mode]="'rating'"></app-timer>
      <app-controls-slot *ngIf="canControlSlot()" [slot]="slot" [candidate]="candidate" [group]="group" [mode]="'rating'"></app-controls-slot>
    </div>
  </div>
  <!-- RATING + NOT AUTHED -->
  <div *ngIf="slot.rating_start === 'end' && auth.isCandidate() && !isLastSlot()" class="slot-line p-d-flex p-jc-between short-break">
    <div class="name" *ngIf="getStartTime('rating') as time">
      {{ time | timezoneTime | amDateFormat: 'HH:mm' }}&nbsp;
      <span class="timezone-times">({{ time | amDateFormat: 'HH:mm' }})&nbsp;</span>
      <ng-container>{{ t('common.labels.short_break') }}</ng-container>
    </div>
  </div>
</ng-container>
